'use strict';
module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./~/react-widgets/~/dom-helpers/util/inDOM.js
// module id = 89
// module chunks = 0